import { AxiosResponse } from 'axios'
import humps from 'humps'

async function keyFormatterInterceptor(response: AxiosResponse): Promise<AxiosResponse> {
    response.data = humps.camelizeKeys(response.data)
    return response
}

export { keyFormatterInterceptor }